import React from 'react';
import classNames from 'classnames';

import NimaLoadingVisual from './NimaLoadingVisual';

const indicatorToneClassNames = {
  auto: 'nima-loading-indicator--auto',
  brand: 'nima-loading-indicator--brand',
  light: 'nima-loading-indicator--light',
  teal: 'nima-loading-indicator--teal'
};

/**
 * Indicador de carregamento em tamanho de componente.
 *
 * Porte de MVF/packages/ui/src/shared/loading/NimaLoadingIndicator.tsx:75-144.
 * O rotulo acessivel e uma unica regiao polite e atomica; o simbolo e sempre
 * decorativo para a tecnologia assistiva, para nao ser anunciado duas vezes.
 */
const NimaLoadingIndicator = ({
  label = 'Carregando…',
  supportingText,
  size = 'md',
  tone = 'brand',
  showLabel = true,
  className,
  style,
  role,
  'aria-live': ariaLive,
  'aria-atomic': ariaAtomic,
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
  ...props
}) => {
  const decorative = ariaHidden === true || ariaHidden === 'true';
  const announcedLabel = ariaLabel || label;
  const visualTone = tone === 'auto' ? 'brand' : tone;
  const rootClassName = classNames(
    'nima-loading-indicator',
    indicatorToneClassNames[tone],
    className
  );

  if (decorative) {
    return (
      <span {...props} aria-hidden="true" className={rootClassName} style={style}>
        <NimaLoadingVisual size={size} tone={visualTone} />
      </span>
    );
  }

  return (
    <span
      {...props}
      className={rootClassName}
      style={style}
      role={role || 'status'}
      aria-live={ariaLive || 'polite'}
      aria-atomic={ariaAtomic || 'true'}
      aria-label={ariaLabel}
    >
      <NimaLoadingVisual size={size} tone={visualTone} />
      <span className={showLabel ? 'nima-loading-indicator__label' : 'nima-sr-only'}>
        {showLabel ? (
          <React.Fragment>
            {label}
            {supportingText ? (
              <small className="nima-loading-indicator__supporting-text">{supportingText}</small>
            ) : null}
          </React.Fragment>
        ) : (
          announcedLabel
        )}
      </span>
    </span>
  );
};

export default NimaLoadingIndicator;
